<template>
    <div class="login">
      <div class="container">
        <h3>欢迎使用<br>爱记录后台管理系统</h3>
        <br>
        <el-form :model="form" ref="form" label-width="0px" :rules="rules">
          <el-form-item label="" prop="username">
            <el-input v-model="form.username" placeholder="请输入账号" clearable>
              <template slot="prefix">
                <i class="el-input__icon el-icon-user"></i>
              </template>
            </el-input>
            
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" clearable show-password v-model.trim="form.password" placeholder="请输入登录密码"
              >
              <template slot="prefix">
                <i class="el-input__icon el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-checkbox  v-model="form.rememberme" style="margin:0px 200px 25px 0px;"  class="remember-checkbox"
          >记住密码</el-checkbox>
          <el-button   style="background:#DE99C4;border-color:#DE99C4"
          type="primary" @click="handleLogin">登录</el-button>
        </el-form>
      </div>
      <div class="el-login-footer">
          <span>Copyright @2013-2025 <a href="http://triplefireman.com" target="_blank">triplefireman.com</a> 版权所有</span>
        </div>
    </div>
  </template>
  
  <script>
  import { encrypt,decrypt } from '@/utils/jsencrypt';
  import Cookies from 'js-cookie';
  import request from '@/utils/request';
  import router from '@/router';
  export default {
    name: 'LoginView',
    data() {
      return {
        form: {
          username: '',
          password: '',
          rememberme: false,
        },
        showPasswordIcon: false,
        isPasswordVisible: false,
        rules: {
          password: [{ required: true, message: '密码不能为空', trigger: ['blur', 'change'] }],
          username:[{required:true,message:'账号不能为空',trigger:['blur','change']}]
        }
      };
    },
    mounted () {
        this.getCookie()
      },
    methods: {
      
      // 登录
      handleLogin() {
        this.$refs.form.validate(async valid => {
          if (valid) {  
            // 提交表单
            await request.post('SportRecord/api/login/',{
                'username':this.form.username,
                'password':this.form.password
            }).then((result)=>{
              let data = result.data
            if (result.code == 200) {
                this.$message.success('请求成功')
                window.sessionStorage.setItem('token',data.token)
                window.sessionStorage.setItem('currentUser',JSON.stringify(data))
                window.sessionStorage.setItem('menuList',JSON.stringify(data.menuList))
                this.$store.commit('SET_AVATOR',data.avator)
              if (this.form.rememberme) {
                Cookies.set('username', this.form.username, { expires: 30 })
                Cookies.set('password', encrypt(this.form.password), { expires: 30 })
                Cookies.set('rememberme', this.form.rememberme, { expires: 30 })
              } else {
                Cookies.remove('username')
                Cookies.remove('password')
                Cookies.remove('rememberme')
              }
              router.replace('/')
            }
            })
          } else {
            console.log('验证失败')
          }
        })
  
      },

      getCookie(){        
        const username = Cookies.get('username')
        const password = Cookies.get('password')
        const rememberme = Cookies.get('rememberme')
        this.form = {
          username : username == undefined ? this.form.username : username,
          password : password == undefined ? this.form.password : decrypt(password),
          rememberme: rememberme == undefined ? false : Boolean(rememberme)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  ::v-deep .el-form-item__label {
    color: #5922ff;
    /* 设置字体颜色 */
  }
  
  .login {
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;
    /* 垂直居中 */
    height: 100vh;
    /* 设置为视口高度 */
    /* background: linear-gradient(to right, #4facfe, #00f2fe); */
    /* 渐变背景 */
    background-image: url('../assets/big_kc.png');
    background-size : cover;
  }
  
  .container {
    background-color: #ffffff;
    /* 改为白色背景 */
    padding: 40px;
    /* 调整内边距 */
    border-radius: 15px;
    /* 圆角效果 */
    width: 350px;
    /* 设置宽度 */
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    /* 更明显的阴影效果 */
    text-align: center;
    
    /* 文本居中 */
  }
  
  h1 {
    font-size: 24px;
    /* 调整标题大小 */
    color: #333;
    /* 标题颜色 */
    margin-bottom: 20px;
    /* 标题与表单间距 */
  }
  
  .el-form-item {
    margin-bottom: 20px;
    /* 表单项间距 */
  }
  
  .el-button {
    width: 100%;
    /* 按钮宽度填满 */
    padding: 10px;
    margin-left: 0px;
    /* 按钮内边距 */
    font-size: 16px;
    /* 按钮字体大小 */
  }
  
  .des {
    font-size: 13px;
    color: #5922ff;
    text-align: left;
    padding-left: 30px;
    background-color: antiquewhite;
  }

  .el-login-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    color: #ffffff;
    height: 40px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
    letter-spacing: 1px;
    line-height: 40px;
    text-align: center;
  }
::v-deep .el-input__inner:focus {
  border-color: #DE99C4;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #DE99C4;
  border-color: #DE99C4;
}

/* 选中状态 */
::v-deep .remember-checkbox.is-checked .el-checkbox__inner {
  background-color: #DE99C4;
  border-color: #DE99C4;
}

/* 未选中边框 */
::v-deep .remember-checkbox .el-checkbox__inner {
  border-color: #DE99C4 !important;
}

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    /* 包括内边距和边框在内的宽高 */
  }
  </style>